module.exports = __webpack_public_path__ + "img/upload-scan.e86d5fb4.svg";